import { GoSquareFill } from "react-icons/go";
import styles from "./SingleCourseCard.module.css";

const SingleCourseCard = ({ course }) => {
  return (
    <div>
      <div className={styles.singleCourseCardContainer}>
        {course.map((item) => {
          const { img, title, info, outcomes, id } = item;
          return (
            <div key={id} className={styles.cardDetails}>
              <div className={styles.cardImg}>
                <img src={img} alt={title} />
              </div>
              <div className={styles.info}>
                <p className={styles.title}>{title}</p>
                <div className={styles.subtitle}>Course Overview</div>
                <div className={styles.courseInfo}>{info}</div>
                <div className={styles.outcomesHeading}>Learning Outcomes</div>
                {outcomes.map((item, index) => {
                  return (
                    <div key={index} className={styles.outcomeSection}>
                      <span>
                        <GoSquareFill />
                      </span>
                      {item}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default SingleCourseCard;
